import React from "react";
import { Sparkles, MapPin, Rocket, Gamepad2, Bike, Camera, Code } from "lucide-react";

function AboutCard() {
  return (
    <div className="space-y-8 py-4">
      <div className="space-y-4">
        <h2 className="text-2xl md:text-3xl font-bold font-manrope text-white flex items-center gap-3">
          Hey There! <span className="animate-pulse">👋</span> I'm <span className="text-primary">Vijay Benal</span>
        </h2>
        <p className="text-neutral-400 text-lg leading-relaxed">
          A passionate <span className="text-primary font-semibold">Full Stack Developer</span> from 
          <span className="text-neon flex items-center gap-1 inline-flex mx-1"><MapPin size={18}/> Bagalkot, India</span>, 
          dedicated to building seamless and impactful digital experiences.
        </p>
      </div>

      <div className="space-y-4">
        <p className="text-neutral-400 leading-relaxed">
          I specialize in developing <span className="text-white font-medium">scalable web solutions</span> 
          using React.js, Node.js, and FastAPI. Currently at 
          <span className="text-primary font-semibold mx-1">Graphene AI</span>, 
          I focus on merging AI with modern web ecosystems to create intelligent, user-centric products.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-dark/50 p-6 rounded-2xl border border-white/5 space-y-3">
          <h3 className="text-lg font-bold text-primary flex items-center gap-2">
            <Rocket size={20} /> What Drives Me?
          </h3>
          <p className="text-sm text-neutral-500">
            Solving real-world challenges through technology—from AI-powered chatbots to high-performance microservices.
          </p>
        </div>
        
        <div className="bg-dark/50 p-6 rounded-2xl border border-white/5 space-y-3">
          <h3 className="text-lg font-bold text-neon flex items-center gap-2">
            <Code size={20} /> My Philosophy
          </h3>
          <p className="text-sm text-neutral-500 italic">
            "Code is more than syntax—it's the art of crafting solutions that simplify lives."
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-xl font-bold text-white flex items-center gap-2">
          <Sparkles size={22} className="text-primary" /> Beyond Code
        </h3>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { icon: <Rocket size={18}/>, text: "Exploring AI Advancements" },
            { icon: <Gamepad2 size={18}/>, text: "Competitive Gaming 🎮" },
            { icon: <Bike size={18}/>, text: "Road Tripping 🏍️" },
            { icon: <Camera size={18}/>, text: "Travel Photography 📸" }
          ].map((item, index) => (
            <li key={index} className="flex items-center gap-3 text-neutral-400 bg-white/5 px-4 py-2 rounded-xl border border-white/5">
              <span className="text-primary">{item.icon}</span>
              {item.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AboutCard;
